//Base Api address
export const MIDDLEWARE_BASE_URL='https://nc-middleware-dev.regionstest.com/';

//Banking Alerts related URLs
export const BANKING_ALERTGROUPS_ENDPOINT='api/BankingAlertGroups';
export const DELIVERY_CHANNELS_CONFIG = "api/deliveryChannels"
export const SAVE_BANK_ACCOUNTS = 'api/accounts/'

//Account Alert related URLs
export const CUSTOMER_PROFILES_ENDPOINT='api/CustomerProfile';
export const ALERT_Registrations_ENDPOINT='/api/AlertRegistrations';
export const ALERT_TYPES_ENDPOINT='/api/Accounts/{number}/AlertTypes';

export const CONTACT_PREFERENCES_ENDPOINT='api/BankingAlertGroups';
export const DELIVERYMETHODS_ENDPOINT='/api/DeliveryMethods';






